var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeader2 = function SvgHeader2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1447.27-6.188v138.753c-18.44 98.559-68.33 159.978-332.79 159.978-339.321 0-637.477-286.793-1120.87-60.03v-238.7h1453.66Z",
    fill: "#7289DA"
  })));
};

export default SvgHeader2;